import { render } from "@/components/pages/individualWorkSupport/requirement022/Requirement022.html?vue&type=template&id=1ae35f2b&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement022/Requirement022.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement022/Requirement022.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement022/Requirement022.scss?vue&type=style&index=0&id=1ae35f2b&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae35f2b"]])

export default __exports__